import api from './api';

export const loginApi = (email, password) =>
  api.post('/auth/login', { email, password });

export const getMeApi = () =>
  api.get('/auth/me');
